import FormSelect, { FormSelectProps, SelectOption } from 'components/new-ui/composed/formSelect/FormSelect';
import { MANIFEST_STATUS_MAP, ManifestStatus } from 'views/manifests/types/manifest-statuses';

type ManifestSelectOptions = Omit<FormSelectProps, 'selectOptions'> & {};

const manifestStatusOptions: SelectOption[] = Object.entries(MANIFEST_STATUS_MAP).map(([status, config]) => ({
    id: status as ManifestStatus,
    value: config.label,
}));

const ManifestStatusSelect = (props: ManifestSelectOptions) => {
    return (
        <FormSelect
            hideKeys
            selectOptions={manifestStatusOptions}
            renderOptionContent={(item) => {
                const status = item.id as ManifestStatus;
                const color = MANIFEST_STATUS_MAP[status].color;
                const text = MANIFEST_STATUS_MAP[status].label;

                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span
                            style={{
                                width: 8,
                                height: 8,
                                borderRadius: '50%',
                                backgroundColor: color,
                                flexShrink: 0,
                            }}
                        />
                        <span>{text}</span>
                    </div>
                );
            }}
            {...props}
        />
    );
};

export default ManifestStatusSelect;
